import { Component, OnInit, Inject, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogPortfolioCustomLabelsModifyGridLayoutService } from '@irb/irb-dialogs/dialog-portfolio-custom-labels-modify/dialog-portfolio-custom-labels-modify.grid-layout.service';
import { SelectAllGridParent } from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-select-all-grid-parent';
import { IPortfolioCustomLabel } from '@irb/irb-editors/irb-editors.model';

export interface DialogPortfolioCustomLabelsModifyConfig {
  mode: string;
  data: Array<IPortfolioCustomLabel>;
  selection: Array<IPortfolioCustomLabel>;
  finishButtonCallback: Function;
}

@Component({ standalone: false,
  selector: 'irb-dialog-portfolio-custom-labels-modify',
  templateUrl: './dialog-portfolio-custom-labels-modify.component.html',
  styleUrls: ['./dialog-portfolio-custom-labels-modify.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DialogPortfolioCustomLabelsModifyComponent implements OnInit, SelectAllGridParent {
  isAddMode: boolean = true;
  isSingleMode: boolean = true;
  gridOptions: any;
  data: Array<IPortfolioCustomLabel>;
  selection: Array<IPortfolioCustomLabel>;
  grid: any;
  params: any;
  gridHeight: string;
  uniqueField: string = "id";
  noRowsOverlayComponentParams: any;
  footerContent: string;
  totalSelectCount: number;
  totalRecordsFromServer: number;
  isSelectedAll: boolean;
  deselectedFromSelectAllRecords: Array<any> = [];
  headerCheckBoxState: string;
  disableActionBtn: boolean;
  finishButtonCallback: Function;

  constructor(public dialogRef: MatDialogRef<DialogPortfolioCustomLabelsModifyComponent>, 
    @Inject(MAT_DIALOG_DATA) public mdd: DialogPortfolioCustomLabelsModifyConfig,
    private gls: DialogPortfolioCustomLabelsModifyGridLayoutService) {
      this.isAddMode = (mdd.mode.toUpperCase() == "SINGLE_EDIT_ADD") || (mdd.mode.toUpperCase() == "MULTIPLE_EDIT_ADD");
      this.isSingleMode = (mdd.mode.toUpperCase() == "SINGLE_EDIT_ADD") || (mdd.mode.toUpperCase() == "SINGLE_EDIT_REMOVE");
      this.finishButtonCallback = this.mdd.finishButtonCallback;
      this.selection = this.mdd.selection;
    }

  ngOnInit(): void {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(this),
      frameworkComponents: this.gls.getFrameworkComponents(),
      floatingFilter: true,
      context: { componentParent: this }
    };

    this.data = this.mdd.data as Array<IPortfolioCustomLabel> || [];

    this.noRowsOverlayComponentParams = {
      onOpenGlobalSettings: () => { this.close(); },
      canRemoveLabels: this.data.length > 0,
      isAddMode: this.isAddMode
    };
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
    this.params = params;
    
    if(this.selection?.length > 0) {
      let selectedIds = this.selection.map((x: IPortfolioCustomLabel) => x.id);
      this.grid?.api.forEachNode((node: any) => {
        if(selectedIds.includes(node.data.id)) {
          node.setSelected(true);
        }
      });
    }

    if(this.data.length > 10) {
      this.grid.api.setGridOption("domLayout",'normal');
      this.gridHeight = "330px";
    } else if(this.data.length == 0) {
      this.grid.api.setGridOption("domLayout",'normal');
      this.gridHeight = "200px";
    } else {
      this.grid.api.setGridOption("domLayout",'autoHeight');
      this.gridHeight = "100%";
    }

    this.footerContent = this.data.length + " Labels";
    this.enableDisableBtns();
  }

  enableDisableBtns() {
    this.totalSelectCount = this.grid?.api.getSelectedRows().length;
  }

  clearAllFilters() {
    this.grid?.api.setFilterModel(null);
  }

  callFinishButtonCallback() {
    if (this.mdd.finishButtonCallback) {
      this.finishButtonCallback(this.grid?.api?.getSelectedRows());
      this.close();
    }
  }
}
